@if (showTopMessage) {
  <div style="padding: 10px">
    <span>{{topMessage}}</span>
  </div>
}
<app-tab-header [hidden]="isFirstTimeLoading">
  <div class="d-flex pb-2">
    <!-- standard configuration switch and selector  -->
    <div>
      @if (isDraftEstimate) {
        <div>
          <app-standard-config-sync [iProjectId]="iProjectId()" [iProjectTypeId]="iProjectTypeId()"
            [disabled]="disableAllButtons" (SyncStandardConfig)="onStdConfigChange($event)"
            [iProjectStatusId]="iProjectStatusId()" [iProjectEstimateId]="iProjectEstimateId()">
          </app-standard-config-sync>
        </div>
      }
    </div>
    <div class="ms-auto">
      @if (publishingProject || disableAllButtons) {
        <kendo-loader type="converging-spinner" size="small" style="margin-right: 0.5rem;"></kendo-loader>
      }
      @if (isDraftEstimate) {
        @if (showEstimateCompareButton) {
          <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.swap"
            [disabled]="disableAllButtons || publishingProject || hasPendingChange" (click)="compareEstimate()">
            Compare
          </button>
        }
        <kendo-splitbutton #syncButton themeColor="primary" [data]="syncButtonData" [svgIcon]="icons.refresh"
          (buttonClick)="addSyncButtonLogic(); syncButton.togglePopupVisibility()" (open)="addSyncButtonLogic()">
          Sync
        </kendo-splitbutton>
        <kendo-splitbutton #addButton themeColor="primary" [data]="addButtonData" [svgIcon]="icons.plusCircle"
          (buttonClick)="addActionButtonLogic(); addButton.togglePopupVisibility()" (open)="addActionButtonLogic()">
          Add
        </kendo-splitbutton>
        <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.xCircle" (click)="onDelete()"
          [disabled]="publishingProject || disableAllButtons">
          Remove
        </button>
        <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.save"
          [disabled]="publishingProject || !hasPendingChange || disableAllButtons" (click)="onSave()">
          Save
        </button>
        <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.cancel"
          [disabled]="publishingProject || !hasPendingChange || disableAllButtons" (click)="onCancel()">
          Cancel
        </button>
      }
      <kendo-splitbutton #xAfeActionButton [data]="xAfeActionButtonData" themeColor="primary"
        (buttonClick)="xAfeActionButtonLogic(); xAfeActionButton.togglePopupVisibility()"
        (open)="xAfeActionButtonLogic()">
        Action
      </kendo-splitbutton>
      <button type="button" #anchor (click)="onExportExcel()" kendoButton themeColor="primary" class="k-button-icon"
        [svgIcon]="icons.excel" [disabled]="hasPendingChange || disableAllButtons"></button>
    </div>
  </div>
  <hr />
  <form novalidate [formGroup]="headerForm">
    <div class="row pt-2">
      <div class="col-md-2">
        <div class="form-group">
          <label for="estStatus" style="margin-bottom: 0rem;">Status</label>
          <input id="estStatus" [disabled]="true" [value]="estimateStatus" class="k-textbox form-control" />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          @if (isDraftEstimate) {
            <input type="radio" kendoRadioButton id="inputPercent" name="IsTaxPercent" class="k-radio"
              [checked]="projectEstimate.IsTaxPercent" (change)="onIsTaxPercentChanged(true)" />
          }
          <label class="k-radio-label" for="inputPercent"> Tax %</label>
          <kendo-numerictextbox formControlName="taxControl" class="text-right form-control"
            [(ngModel)]="projectEstimate.TaxControl" [format]="'p1'" [step]="0.01" [min]="0" [max]="1"
            (valueChange)="onTaxChanged($event)">
          </kendo-numerictextbox>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          @if (isDraftEstimate) {
            <input type="radio" kendoRadioButton id="inputTaxText" name="IsTaxPercent" class="k-radio"
              [checked]="!projectEstimate.IsTaxPercent" (change)="onIsTaxPercentChanged(false)" />
          }
          <label class="k-radio-label" for="inputTaxText">Tax Cost</label>
          @if (saving) {
            <kendo-loader type="converging-spinner" size="small"></kendo-loader>
          }
          <kendo-numerictextbox formControlName="taxCostControl" class="text-right form-control"
            [(ngModel)]="projectEstimate.TaxCostControl" [format]="'c0'" [spinners]="false" (valueChange)="onTaxChanged($event)">
          </kendo-numerictextbox>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          @if (isDraftEstimate) {
            <input type="radio" kendoRadioButton id="inputContingencyPercent" name="IsContingencyPercent" class="k-radio"
              [checked]="projectEstimate.IsContingencyPercent" (change)="onIsContingencyPercentChanged(true)" />
          }
          <label class="k-radio-label" for="inputContingencyPercent">Contingency %</label>
          <kendo-numerictextbox formControlName="contingencyControl" [(ngModel)]="projectEstimate.ContingencyControl"
            class="text-right form-control" [format]="'p1'" [step]="0.01" [min]="0" [max]="1"
            (valueChange)="onContingencyChanged($event)">
          </kendo-numerictextbox>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          @if (isDraftEstimate) {
            <input type="radio" kendoRadioButton id="inputContingencyText" name="IsContingencyPercent" class="k-radio"
              [checked]="!projectEstimate.IsContingencyPercent" (change)="onIsContingencyPercentChanged(false)" />
          }
          <label class="k-radio-label" for="inputContingencyText">Contingency Cost</label>
          @if (saving) {
            <kendo-loader type="converging-spinner" size="small" style="margin-bottom: 0.25rem; margin-left:0.25rem;"></kendo-loader>
          }
          <kendo-numerictextbox formControlName="contingencyCostControl"
            [(ngModel)]="projectEstimate.ContingencyCostControl" class="text-right form-control" [format]="'c0'"
            [spinners]="false" (valueChange)="onContingencyChanged($event)">
          </kendo-numerictextbox>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label for="inputTotal" style="margin-bottom: 0rem;">Total</label>
          @if (saving) {
            <kendo-loader type="converging-spinner" size="small" style="margin-bottom: 0.25rem; margin-left:0.25rem;"></kendo-loader>
          }
          <kendo-numerictextbox id="inputTotal" class="text-right form-control" [format]="'c0'"
            [value]="projectEstimate.EstimateTotal" [spinners]="false" [disabled]="true">
          </kendo-numerictextbox>
        </div>
      </div>
    </div>
  </form>
  <div class="row pt-2">
    <div class="col-md-10" style="font-size: 14px;">
      <strong>Estimate Notes: </strong> {{ projectEstimate.RecordDescription }}
      @if (hasNoSchedule) {
        <div style="border:1px solid black; padding:.25em">
          <h3 style="color: red; font-size: 16px; font-weight: bold; margin:0">No Schedule Found or has an Invalid
            Schedule</h3>
          <h4 style="margin:0">This project does not have a valid schedule! The project cannot be used without one.</h4>
          <p>This indicates a significant data issue. <i>Please contact the support team.</i></p>
        </div>
      }
      @if (missingPadConstructionWbsWarnings.length > 0) {
        <div style="border:1px solid black; padding:.25em; margin-top:.5em">
          <h3 style="color: red; font-size: 16px; font-weight: bold; margin:0">Pad Construction WBS Warning</h3>
          <ul style="margin:0">
            @for (warning of missingPadConstructionWbsWarnings; track warning) {
              <li>{{ warning }}</li>
            }
          </ul>
        </div>
      }
      @if (hasEstimateDuplicateItems) {
        <div>
          <div>Cannot save estimate due to duplicate Item #, GFCM #, Phase and Step as follows:</div>
          <ul>
            @for (msg of duplicateEstimateItems; track msg) {
              <li>{{ msg }}</li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
  <hr />
</app-tab-header>

<ag-grid-angular #agGridProjectEstimate style="height: 100%; min-height: 400px;" class="ag-theme-balham"
  [gridOptions]="gridOptions" [columnDefs]="columnDefs" [rowClassRules]="rowClassRules"
  (gridReady)="onGridReady($event)" (cellValueChanged)="onCellValueChanged($event)"
  (rowSelected)="onMasterGridRowSelected($event)">
</ag-grid-angular>

@if (publishingProject) {
  <kendo-dialog title="{{ progressDialog.DialogTitle }}" (close)="onProgressMessageClose()" minWidth="600"
    maxWidth="50vw">
    <div style="margin: 30px; text-align: center">
      <h4><strong>{{ progressDialog.Message }}</strong></h4>
      <br />
      <ul class="mb-0 no-bullets">
        @for (message of progressDialog?.Progress; track message; let i = $index) {
          <li style="text-align: left">
            @if (message.InProgress) {
              <kendo-loader type="converging-spinner" size="small"></kendo-loader>
            } @else if (message.IsSuccess) {
              <kendo-svgicon [icon]="icons.check" style="color: green"></kendo-svgicon>
            } @else if (message.IsErrored) {
              <kendo-svgicon [icon]="icons.xCircle" style="color: red"></kendo-svgicon>
            }
            {{ message.StepMessage }}
          </li>
        }
      </ul>
      <br />
      <ul class="mb-0">
        @for (message of progressDialog.ErrorMessage; track message; let i = $index) {
          <li style="text-align: left">
            {{ message }}
          </li>
        }
      </ul>
    </div>
    <div style="text-align: center">
      @if (processComplete) {
        <button type="button" kendoButton themeColor="primary" style="text-align: right" (click)="onProgressMessageClose()">
          Close
        </button>
      }
    </div>
  </kendo-dialog>
}

@if (showGeneratingEstimateDialog || isFirstTimeLoading) {
  <kendo-dialog title="Generating Estimate">
    <p style="margin: 30px; text-align: center">
      Generating Project Estimate Line Items
    </p>
  </kendo-dialog>
}

@if (showConfirmSyncDialog) {
  <kendo-dialog title="Sync Draft Estimate Items" maxWidth="40vw" maxHeight="50vh"
    (close)="this.showConfirmSyncDialog = false;">
    <p style="margin: 10px; text-align: center">This action will cause the draft estimate item(s) to be synced. Would you
      like to proceed?</p>
    <br />
    <ul class="mb-0 bullets">
      @if (itemsToAddAfterSync.length > 0) {
        <li style="margin-left: 20px; text-align: left">
          {{ itemsToAddAfterSync.length }} item(s) with below item number(s) will be added<br />
          @for (item of itemsToAddAfterSync; track item; let i = $index) {
            <span class="mb-0 no-bullets">{{ item.ItemNumber }}&ensp;</span>
          }<br />
          <span class="mb-0 no-bullets"><br /></span>
        </li>
      }
      @if (itemsToDeleteAfterSync.length > 0) {
        <li style="margin-left: 20px; text-align: left">
          {{ itemsToDeleteAfterSync.length }} item(s) with below item number(s) will be removed<br />
          @for (item of itemsToDeleteAfterSync; track item; let i = $index) {
            <span class="mb-0 no-bullets">{{ item.ItemNumber }}&ensp;</span>
          }<br />
          <span class="mb-0 no-bullets"><br /></span>
        </li>
      }
      @if (itemsToUpdateAfterSync.length > 0) {
        <li style="margin-left: 20px; text-align: left">
          {{ itemsToUpdateAfterSync.length }} item(s) with below item number(s) will be updated<br />
          @for (item of itemsToUpdateAfterSync; track item; let i = $index) {
            <span class="mb-0 no-bullets">{{ item.ItemNumber }}&ensp;</span>
          }<br />
          <span class="mb-0 no-bullets"><br /></span>
        </li>
      }
      @if (manualItemsToDeleteAfterSync.length > 0) {
        <li style="margin-left: 20px; text-align: left">
          {{ manualItemsToDeleteAfterSync.length }} manual item(s) with below item number(s) will be removed<br />
          @for (item of manualItemsToDeleteAfterSync; track item; let i = $index) {
            <span class="mb-0 no-bullets">{{ item.ItemNumber }}&ensp;</span>
          }
        </li>
      }
    </ul>
    <kendo-dialog-actions>
      <button type="button" kendoButton (click)="continueToSync()" themeColor="primary">Yes</button>
      <button type="button" kendoButton (click)="this.showConfirmSyncDialog = false;">No</button>
    </kendo-dialog-actions>
  </kendo-dialog>
}

@if (showUpdateAFEDialog) {
  <kendo-dialog title="Update WBS" minWidth="20vw" maxWidth="40vw" maxHeight="50vh"
    (close)="this.showUpdateAFEDialog = false;">
    <p>Select Reason for WBS Update:</p>
    <kendo-dropdownlist [data]="reasonsToUpdateAFE" [(ngModel)]="selectedReasonId" [textField]="'Description'"
      [valueField]="'AFEUpdateReasonId'" [valuePrimitive]="true">
    </kendo-dropdownlist>
    <kendo-dialog-actions>
      <button type="button" kendoButton [disabled]="!selectedReasonId" (click)="continueToUpdateAFE()"
        themeColor="primary">Continue</button>
      <button type="button" kendoButton (click)="this.showUpdateAFEDialog = false;">Cancel</button>
    </kendo-dialog-actions>
  </kendo-dialog>
}

@if (nothingToSyncDialog) {
  <kendo-dialog title="Sync Draft Estimate Items" (close)="this.nothingToSyncDialog = false;">
    <p style="margin: 20px; text-align: center">The selected draft estimate item(s) are already in sync!</p>
    <kendo-dialog-actions>
      <button type="button" kendoButton (click)="this.nothingToSyncDialog = false;">OK</button>
    </kendo-dialog-actions>
  </kendo-dialog>
}

@if (isCcctDialogOpen) {
  <app-ccct-select
    [showDialog]="isCcctDialogOpen"
    [showPhaseStep]="IsDrillingOrCompletion() && distinctPhaseStep.length > 0"
    [iProjectTypeId]="iProjectTypeId()"
    [iDistinctPhaseStep]="distinctPhaseStep"
    (addCcctItem)="addNewCcctItem($event)"
    (closeDialog)="closeDialog()">
  </app-ccct-select>
}

@if (isItemsDialogOpen) {
  <app-project-item-select
    [showDialog]="isItemsDialogOpen"
    [showPhaseStep]="IsDrillingOrCompletion() && distinctPhaseStep.length > 0"
    [iProjectTypeId]="iProjectTypeId()"
    [iDistinctPhaseStep]="distinctPhaseStep"
    (addItem)="addNewItems($event)"
    (closeDialog)="closeDialog()">
  </app-project-item-select>
}